import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Assignment } from '~app/shared/models/assignment';
import { CrewEffects } from '~app/shared/models/crewEffects.model';
import { CrewPhysique } from '~app/shared/models/crewPhysique.model';
import { Profile } from '~app/shared/models/profile.model';
import { User } from '~app/shared/models/user.model';
import { DataUtilsService } from '../data-utils/data-utils.service';
import { MwService } from '../mw/mw.service';
import { StoreService } from '../store/store.service';
import { IUpdateCrewProfileResponse } from './models/update-crew-profile-response';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private readonly mw: MwService,
    private readonly dataUtils: DataUtilsService,
    private readonly store: StoreService,
  ) {}

  public async loadProfile(user: User): Promise<void> {
    await this.dataUtils.ensureCountries();
    const profileData = await this.mw.getCrewMemberProfile(user.id).toPromise();
    const profile = new Profile(profileData.payload, this.store.countries);
    user.profile = profile;
  }

  public async loadCrewPhysique(user: User): Promise<void> {
    const physiqueData = await this.mw.getCrewPhysique(user.id).toPromise();
    user.crewPhysique = new CrewPhysique(physiqueData.payload.characteristics);
  }

  public async loadCrewEffects(user: User): Promise<void> {
    await this.dataUtils.ensureEffectItems();
    const crewEffectsData = await this.mw.getCrewEffects(user.id).toPromise();
    user.crewEffects = new CrewEffects(crewEffectsData.payload, this.store.effectItems);
  }

  public async loadCrewPhoto(user: User): Promise<void> {
    try {
      const crewPhoto = await this.mw.getCrewPhoto(user.id).toPromise();
      user.profile.photo = crewPhoto;
    } catch (error) {
      user.profile.photo = undefined;
    }
  }

  public async updateCrewPhoto(user: User, assignment: Assignment, picture: File): Promise<void> {
    await this.mw
      .updateCrewPhoto(user.profile.crewMemberId, assignment.ship.code, user.profile.lastName, picture)
      .toPromise();
  }

  public updateCrewProfile(user: User, profile: Partial<Profile> = {}): Observable<IUpdateCrewProfileResponse> {
    return this.mw.updateCrewProfile(user.profile.crewMemberId, profile);
  }

  public async syncCrewPhoto(user: User, assignment: Assignment): Promise<void> {
    await this.mw.syncCrewPhoto(user.profile.crewMemberId, assignment.ship.code, user.profile.lastName).toPromise();
  }
}
